export default function DateGreaterThanDirective($filter, utilitySevice) {
  'ngInject';

  return {
    require: 'ngModel',
    link(scope, elm, attrs, ctrl) {
      const validateDateRange = function (inputValue) {
        const fromDate = $filter('date')(attrs.dateGreaterThan, 'short');
        const toDate = $filter('date')(inputValue, 'short');
        const isValid = utilitySevice.isValidDateRange(fromDate, toDate);
        ctrl.$setValidity('dateGreaterThan', isValid);
        return inputValue;
      };

      scope.$watch(attrs.ngModel, (newValue) => {
        validateDateRange(newValue);
      });
    },
  };
}
